var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-stats-card',_vm._b({attrs:{"title":"Venue charge","value":_vm._f("money")(_vm.value || 0,_vm.currency),"is-loading":_vm.isLoading,"icon":"coins"}},'ui-stats-card',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }